export const CAMPAIGN_PROMPT_STORAGE_KEY = 'campaignPrompt'

export function saveCampaignPromptFromSearch(search = '') {
  const normalizedSearch = search.startsWith('?') ? search.slice(1) : search
  const prompt = new URLSearchParams(normalizedSearch).get('prompt')

  if (!prompt) {
    return
  }

  window.localStorage.setItem(CAMPAIGN_PROMPT_STORAGE_KEY, prompt)
}

export function getStoredCampaignPrompt() {
  if (typeof window === 'undefined') {
    return null
  }

  return window.localStorage.getItem(CAMPAIGN_PROMPT_STORAGE_KEY)
}

export function readInitialCampaignPrompt() {
  return getStoredCampaignPrompt()?.trim() || ''
}

export function clearStoredCampaignPrompt() {
  window.localStorage.removeItem(CAMPAIGN_PROMPT_STORAGE_KEY)
}

export function consumeStoredCampaignPrompt() {
  const prompt = getStoredCampaignPrompt()

  if (!prompt) {
    return null
  }

  clearStoredCampaignPrompt()
  return prompt
}
